import React, { Component } from "react";
import Row from "../../../common/grid/Row";
import { connect } from "react-redux";
import { fetchUsers, deleteUser } from "../../../actions/user.js";
import BrowserHistory from "../../../providers/BrowserHistory.js";
import Modal from "../../../common/modal/Modal.js";
import SearchInput from "../../../common/input/SearchInput";
import UserCard from "../../../common/userCard/UserCard";
import AddUserButton from "./AddUserButton";

import "./UserManagement.css";

class UserManagement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			confirmed: false,
			userId: null,
			filterText: ""
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.onAddNewBoxClick = this.onAddNewBoxClick.bind(this);
		this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
	}

	onAddNewBoxClick() {
		BrowserHistory.push("/main/users/add");
	}

	onDeleteClick(userId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, userId });
	}

	onDeleteConfirm() {
		this.setState({ showModal: false, confirm: true });
		this.props.deleteUser(this.state.userId);
	}

	onEditClick(userId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/users/${userId}/edit`);
	}

	onUserBoxClick(userId) {
		BrowserHistory.push(`/main/users/${userId}/details`);
	}

	componentDidMount() {
		this.props.fetchUsers();
	}

	handleInputChange(filterText) {
		this.setState({ filterText });
	}

	render() {
		const { users } = this.props;
		if (!this.props.users) {
			return null;
		}

		const filteredUsers = users.filter(u => {
			const name = u.first_name.toLowerCase() + " " + u.last_name.toLowerCase();
			return name.includes(this.state.filterText.toLowerCase());
		});

		return (
			<div className="user-management">
				<Row _space-between title>
					<h2>Manage users</h2>
					<SearchInput onChange={this.handleInputChange} ph={"search users"} />
				</Row>
				{this.state.showModal && (
					<Modal
						type="CONFIRMATION"
						onConfirm={this.onDeleteConfirm}
						onCancel={() => this.setState({ confirm: false, showModal: false })}
						show={this.state.showModal}
					>
						Are you sure you want to delete this user?
					</Modal>
				)}
				<Row _gap-16 _wrap _no-grow _no-align>
					<AddUserButton onClick={this.onAddNewBoxClick} />
					{filteredUsers.map((user, i) => (
						<UserCard
							key={i}
							user={user}
							onEdit={this.onEditClick.bind(this, user.id)}
							onDelete={this.onDeleteClick.bind(this, user.id)}
							onUserBoxClick={this.onUserBoxClick.bind(this, user.id)}
						/>
					))}
				</Row>
			</div>
		);
	}
}

const mapStateToProps = state => {

	return {
		users: state.user.allUsers
	};
};

export default connect(
	mapStateToProps,
	{ fetchUsers, deleteUser }
)(UserManagement);



// WEBPACK FOOTER //
// ./src/components/main/user-management/UserManagement.js